import { connect } from 'react-redux'

import AuthorizedFallbackDisplay from '@components/common/auth/AuthorizedFallbackDisplay'

import presenters from '@presenters'

interface State {
  user: {
    roles: {
      name: string
      headquarterId: number
    }[]
    lastLoggedInHq: number
  }
}

interface AuthorizedFallbackDisplayProps {
  roles?: string[]
  excludeRoles?: string[]
}

const mapStateToProps = (
  state: State,
  ownProps: AuthorizedFallbackDisplayProps,
) => {
  const { roles, excludeRoles } = ownProps
  const authRoles = roles || excludeRoles || []

  const hasRole = presenters.isAuthorized(state.user, authRoles)

  return { visible: excludeRoles ? !hasRole : hasRole }
}

export default connect(mapStateToProps)(AuthorizedFallbackDisplay)
